import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ftchydorvlpfemysaoqn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ0Y2h5ZG9ydmxwZmVteXNhb3FuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY5ODA3OTMsImV4cCI6MjA1MjU1Njc5M30.t-enzk-aXXZlCEPsvzPgQpIqkwGycmjdyQn-FjbjmhA";

let instance: ReturnType<typeof createClient<Database>> | null = null;

// Create a singleton instance with simplified session handling
const createSupabaseClient = () => {
  if (instance) return instance;

  instance = createClient<Database>(
    SUPABASE_URL,
    SUPABASE_PUBLISHABLE_KEY,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
        storageKey: 'supabase.auth.token',
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      }
    }
  );

  return instance;
};

export const supabase = createSupabaseClient();